module.exports = __webpack_public_path__ + "static/media/sexual-health.f5ad9b2c.png";